export interface ExpirableAdvertisement {
  expiresAt?: string;
}

/**
 * An advertisement with no expiresAt never expires. Comparison is
 * day-level (midnight-normalized) — an advert stays active through its
 * entire expiry day, not just up to the exact timestamp.
 */
export function isAdActive(
  ad: ExpirableAdvertisement,
  now: Date = new Date()
): boolean {
  if (!ad.expiresAt) return true;

  const expiryDate = ad.expiresAt.includes("T")
    ? new Date(ad.expiresAt)
    : new Date(ad.expiresAt + "T00:00:00");
  expiryDate.setHours(0, 0, 0, 0);

  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  return expiryDate >= today;
}
